import SvgIcon from '@/pages/home/components/SvgIcon';
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { Bubble, Menu } from 'tea-component';
import {
  Link,
  connect,
  getLocale,
  useHistory,
  useIntl,
  useLocation,
} from 'umi';
import VersionSelection from './VersionSelection';

import { urlToMap } from '@/pages/opinion/utils/url';
import { initialUpperCase } from '@/pages/opinion/utils';
import { statsDetailIdKey } from '@/pages/opinion/utils/storageUtils';
import TextBubbles from '@/pages/home/components/TextBubbles';
import MenuPopover from './MenuPopover';
import { useGetMenuFilterInfo, useMenuOperateInfo } from '../hooks';
import FavoritesMenuItem from './FavoritesMenuItem';
import '../index.scss';
import { OVERALL_DEFAULT_INFO } from '@op/constants';
import { GAME_LIST_URL } from '@op/constants/page';

function NavBody(props: any) {
  // 这个hook使用为了触发文案上的修改
  useIntl();
  const locale = getLocale();
  const { formatMessage } = useIntl();
  const {
    isExpand,
    menuList,
    wholeGameInfo,
    gameInfo,
    userInfo,
    setIsExpand,
    selectMenuItem,
  } = props;
  const history = useHistory();
  const location:any = useLocation();
  const selected = useMemo(() => {
    if (selectMenuItem) return selectMenuItem;
    const reportName = location?.state?.reportName;
    if (reportName) return reportName;
    if (location.pathname === GAME_LIST_URL) return GAME_LIST_URL;
    if (location.pathname === '/opinion') return '/opinion/Overview/KeyMetrics';
    if (location.pathname === '/opinion/Overview') return '/opinion/Overview';
    if (location.pathname === '/opinion/AITaskCenter')
      return '/opinion/AITaskCenter';
    const {redirect, redirect_path} = location?.query || {};
    if (redirect) return redirect;
    if (redirect_path) {
      if(redirect_path.includes("?")){
        return redirect_path?.split("?")?.[0];
      }

      return redirect_path;
    }

    const curPathname = decodeURIComponent(location.pathname);

    for (const element of menuList) {
      const { pathname, listMenu } = element;
      if (listMenu && Array.isArray(listMenu) && listMenu.length > 0) {
        for (const element2 of listMenu) {
          const { pathname: pathname2, type } = element2;
          const newPathname2 = decodeURIComponent(pathname2);

          const newListMenu = element2.listMenu;
          if (
            newListMenu &&
            Array.isArray(newListMenu) &&
            newListMenu.length > 0
          ) {
            for (const element3 of newListMenu) {
              const { pathname: pathname3 } = element3;
              const newPathname3 = decodeURIComponent(pathname3);
              if (curPathname.includes(newPathname3)) {
                return newPathname3;
              }
            }
          }
          // console.log('second level', curPathname, newPathname2, element2);
          if (newPathname2 === '/opinion/Overview') {
            continue;
          }

          if (type === '6') {
            const [path] = newPathname2.split('?');
            if (path === curPathname) return pathname2;
          }

          if (
            ['/opinion/Insights'].includes(curPathname) &&
            newPathname2.includes(curPathname)
          ) {
            return pathname2;
          }
          if (curPathname.includes(newPathname2)) {
            // 进行二段精准匹配，避免前面的路由相同，导致选错问题
            // /a/report  > /a/report/b
            for (const el of listMenu) {
              const newPath = decodeURIComponent(el.pathname);
              if (newPath === curPathname) {
                return newPath;
              }
            }

            return pathname2;
          }

          if (newPathname2.includes(curPathname)) {
            return pathname2;
          }

          // console.log(curPathname, newPathname2, '*------------*', element2);

          if (curPathname === '/opinion/SteamPerformance') {
            return '/opinion/SteamPerformance/SteamRatings';
          }

          // '下钻页要特殊处理高亮',
          // todo 这里可以优化为利用statsDetailType获取到具体目录而不是判断
          if (curPathname === '/opinion/Stats/Detail') {
            const map = urlToMap(window.location.href);
            if (map.get(statsDetailIdKey)) {
              const statsDetailParams =
                sessionStorage.getItem(
                  `statsDetailParams-${map.get(statsDetailIdKey)}`,
                ) || '{}';
              try {
                const curDownLoadParams = JSON.parse(statsDetailParams);
                const { statsDetailChartsData, statsDetailType } =
                  curDownLoadParams;

                const { dataType } = statsDetailChartsData || {};

                console.log(
                  `/opinion/Stats/${initialUpperCase(dataType)}`,
                  statsDetailType,
                );

                if (statsDetailType?.startsWith?.('stats')) {
                  return `/opinion/Stats/${initialUpperCase(dataType)}`;
                }

                if (statsDetailType?.startsWith?.('performance')) {
                  return '/opinion/Overview';
                }

                if (statsDetailType?.startsWith?.('competitor')) {
                  return '/opinion/Competitor';
                }

                if (statsDetailType?.startsWith?.('accounts-account')) {
                  return '/opinion/Accounts/ByAccount';
                }

                if (statsDetailType?.startsWith?.('accounts-channel')) {
                  return '/opinion/Accounts/ByChannel';
                }

                if (statsDetailType?.startsWith?.('summary')) {
                  return '/opinion/Summary/HotEvent';
                }

                if (statsDetailType?.startsWith?.('hero')) {
                  return '/opinion/Hero';
                }

                if (statsDetailType?.startsWith?.('topic-tracking')) {
                  return '/opinion/Summary/TopicTracking';
                }

                if (statsDetailType?.startsWith?.('steam-ratings')) {
                  return '/opinion/SteamPerformance/SteamRatings';
                }

                if (statsDetailType?.startsWith?.('steam-insights')) {
                  return '/opinion/SteamPerformance/Insights';
                }
              } catch (e) {
                console.log(e);
              }
            }
          }
        }
      }

      if (curPathname === decodeURIComponent(pathname)) {
        return pathname;
      }
    }

    return '/opinion/Overview/KeyMetrics';
  }, [location, menuList, selectMenuItem]);

  const getMenuLinkTo = (item: any) => {
    let { edition_unified_id } = wholeGameInfo || {};
    if (!edition_unified_id) {
      edition_unified_id = OVERALL_DEFAULT_INFO.DEFAULT_GAME_ID;
    }
    const linkUrl = item?.actualPath?.includes('?') ? '&' : `?`;
    return `${item.actualPath + linkUrl}gameid=${edition_unified_id}`;
  };

  const renderTitle = useCallback(
    (item: any) => {
      const title = getLocale() === 'en-US' ? item.name_en : item.name_cn;

      if (!title) {
        return item.name_en ?? item.name_cn;
      }

      return title;
    },
    [locale],
  );
  // const [versionGameList, setVersionGameList] = useState([]);
  const [versionUrl, setVersionUrl] = useState('');
  const [versionVisible, setVersionVisible] = useState(false);
  const toVersionPage = async (t: any) => {
    // const data = await getGameList({
    //   need_mobile_editions: true,
    //   edition_unified_ids: [wholeGameInfo.edition_unified_id],
    // });
    // let [gameInfo] = findGameInfo(data, wholeGameInfo.edition_unified_id) || [];
    // setVersionGameList(gameInfo?.mobile_edition_list);
    if (wholeGameInfo?.mobile_edition_list) {
      setVersionUrl(t.actualPath);
      setVersionVisible(!versionVisible);
    } else {
      history.push(
        `${t.actualPath}?gameid=${wholeGameInfo.edition_unified_id}`,
      );
    }
  };

  const { menuFilterInfo, loading, changeMenuFilterInfo, setMenuFilterInfo } =
    useGetMenuFilterInfo({
      gameInfo,
    });

  const {
    mainMenuList,
    favoritesMenuList,
    deleteCallback,
    addCallback,
    sortCallback,
  } = useMenuOperateInfo({
    menuList,
    changeMenuFilterInfo,
    menuFilterInfo,
    setMenuFilterInfo,
  });
  const [openMenuList, setOpenMenuList] = useState<Array<string>>([]);

  useEffect(() => {
    mainMenuList.forEach((e: any) => {
      if (e.defaultOpened) {
        openMenuList.push(e.id);

        // 三级菜单
        if (e.listMenu && e.listMenu.length > 0) {
          e.listMenu.forEach((item: any) => {
            openMenuList.push(item.id);
          });
        }
      }
      const flag = e?.listMenu?.some?.(
        (item: any) => item.actualPath === selected,
      );
      if (flag && !openMenuList.includes(e.id)) {
        openMenuList.push(e.id);
        setOpenMenuList([...openMenuList]);
      }
    });
    setOpenMenuList([...openMenuList]);
  }, [mainMenuList]);

  useEffect(() => {
    mainMenuList.forEach((e: any) => {
      const flag = e?.listMenu?.some?.(
        (item: any) => item.actualPath === selected,
      );
      if (flag && !openMenuList.includes(e.id)) {
        openMenuList.push(e.id);
        setOpenMenuList([...openMenuList]);
      }
    });
  }, [selected]);

  function getIconElement(data: { showNew: boolean; showBeta: boolean }) {
    if (data.showNew) {
      return <span className="left-nav-notice">NEW</span>;
    }
    if (data.showBeta) {
      return <span className="left-nav-notice beta">BETA</span>;
    }
  }

  function getSubMenuIconElement(data: {
    listMenu: any[];
    id: string;
    showNew: boolean;
    showBeta: boolean;
  }) {
    if (openMenuList.includes(data.id) || data.showNew || data.showBeta) {
      return null;
    }
    if (data.listMenu.some((item) => item.showNew)) {
      return <span className="left-nav-notice">NEW</span>;
    }
    if (data.listMenu.some((item) => item.showBeta)) {
      return <span className="left-nav-notice beta">BETA</span>;
    }
  }

  function getMenuClass(e) {
    let commonClass = `menu-context-text-${e.path}`;
    if (e.disabled) {
      commonClass += ' op-menu-disabled';
    }
    if (e.showLock) {
      commonClass += ' --locked';
    }
    return commonClass;
  }

  function onOpenedChange(opened: boolean, id: string) {
    let menuList = [...openMenuList];
    if (opened) {
      menuList.push(id);
    } else {
      menuList = menuList.filter((item) => item !== id);
    }
    setOpenMenuList(menuList);
  }

  function getLockItemElement(
    t: any,
    index: number,
    isPrimary: boolean,
    isTreeLevel = false,
  ) {
    const commonClass = getMenuClass(t);
    const title = renderTitle(t);
    const bubbleContent = t.name_en === 'Report' ? title : null;
    const className = isPrimary ? 'menu-context-primary' : 'menu-context-text';
    return (
      <Menu.Item
        className={`${className} ${commonClass}`}
        key={`${t.id}-${index}`}
        title={
          <div className="left-nav-text-hd">
            <Bubble closeOnScroll dark placement="top" content={bubbleContent}>
              <div className="left-nav-text-hd-flex">
                <TextBubbles className="menu-context-text" text={title} />
                {getIconElement(t)}
              </div>
            </Bubble>
            {t.business_type !== 'out_link' && (
              <MenuPopover
                userInfo={userInfo}
                menuItem={t}
                gameInfo={gameInfo}
                wholeGameInfo={wholeGameInfo}
                addCallback={addCallback}
                showSaveIcon={t.business_type !== 'out_link'}
              />
            )}
          </div>
        }
        icon={
          <SvgIcon className="left-nav-icon" type={t.icon || 'application'} />
        }
        render={(children) => {
          if (t.name_en === 'Version' && !t.showLock) {
            return (
              <span onClick={() => void toVersionPage(t)}>{children}</span>
            );
          }
          if (t.business_type === 'out_link') {
            return (
              <a href={t.assembly_url} target="_blank" rel="noreferrer">
                {children}
              </a>
            );
          }
          return <Link to={getMenuLinkTo(t)}>{children}</Link>;
        }}
        selected={encodeURI(selected) === t.pathname}
      />
    );
  }

  function getSubMenuItemElement(e: any, index: number) {
    const commonClass = getMenuClass(e);
    if (!e.listMenu || e.showLock) {
      return getLockItemElement(e, index, true);
    }

    function renderChildren() {
      return e.listMenu.map((t: any, index2: number) => {
        // 三级菜单渲染
        if ((t.listMenu || []).length > 0) {
          const title = renderTitle(t);
          const isOpen = openMenuList.includes(t.id);
          return (
            <Fragment key={t.id}>
              <div className="dbo-three-level-box">
                <p
                  className={`dbo-three-level-title ${encodeURI(selected).includes(t.pathname) && !isOpen ? 'dbo-selected' : ''}`}
                  onClick={() => {
                    const close =
                      openMenuList.findIndex((item) => item === t.id) > -1;
                    onOpenedChange(!close, t.id);
                  }}
                >
                  <TextBubbles className="menu-context-text" text={title} />
                  {getIconElement(t)}
                  <i
                    className="tea-icon tea-icon-arrowdown"
                    role="img"
                    aria-label="arrowdown"
                  ></i>
                </p>
                <div
                  style={{
                    display: isOpen ? 'block' : 'none',
                  }}
                >
                  {t.listMenu.map((item: any, index3: number) =>
                    getLockItemElement(item, index3, false, true),
                  )}
                </div>
              </div>
            </Fragment>
          );
        }
        return (
          <Fragment key={t.id}>{getLockItemElement(t, index2, false)}</Fragment>
        );
      });
    }

    return (
      <Menu.SubMenu
        className={commonClass}
        opened={openMenuList.includes(e.id)}
        onOpenedChange={(opened) => onOpenedChange(opened, e.id)}
        key={`${e.id}-${index}`}
        icon={
          <SvgIcon className="left-nav-icon" type={e.icon || 'application'} />
        }
        // showNew逻辑开发需调整，此处仅模拟展示，注意类名差异
        title={
          <div className="left-nav-hd">
            <span className={`menu-context-text`}>{renderTitle(e)}</span>
            {getIconElement(e)}
            {getSubMenuIconElement(e)}
          </div>
        }
      >
        {renderChildren()}
      </Menu.SubMenu>
    );
  }

  return (
    <div className="navmenu-bd">
      {isExpand ? (
        <Menu className="menu-context">
          {mainMenuList.map((e: any, index: number) => {
            return getSubMenuItemElement(e, index);
          })}

          <Menu.Group
            title={formatMessage({ id: 'My Reports' })}
            className={`left-nav-group `}
          >
            <Menu.SubMenu
              defaultOpened={false}
              title={
                <Bubble
                  closeOnScroll
                  dark
                  content={formatMessage({ id: 'Add through the directory' })}
                >
                  <div className="left-nav-hd">
                    <span className={`menu-context-text`}>
                      {formatMessage({ id: 'Favorite Page' })}
                    </span>
                  </div>
                </Bubble>
              }
              icon={<SvgIcon className="left-nav-icon" type="star-m" />}
            >
              {favoritesMenuList.map((item: any, index: number) => (
                <FavoritesMenuItem
                  item={item}
                  key={item.id}
                  userInfo={userInfo}
                  gameInfo={gameInfo}
                  wholeGameInfo={wholeGameInfo}
                  favoritesMenuList={favoritesMenuList}
                  index={index}
                  loading={loading}
                  menuFilterInfo={menuFilterInfo?.[item.id] || {}}
                  sortCallback={sortCallback}
                  deleteCallback={deleteCallback}
                  addCallback={addCallback}
                  isSelected={selected === item.name_en}
                ></FavoritesMenuItem>
              ))}
            </Menu.SubMenu>
          </Menu.Group>
        </Menu>
      ) : (
        <div className="width-item">
          <div className="width-item-line"></div>
          {[...mainMenuList, { id: 'favorites', icon: 'star-m' }].map(
            (e: any) => (
              <div
                key={e.id}
                className="width-item-icon"
                onClick={() => setIsExpand()}
              >
                <SvgIcon type={e.icon} />
              </div>
            ),
          )}
        </div>
      )}

      <VersionSelection
        visible={versionVisible}
        versionUrl={versionUrl}
        close={() => setVersionVisible(!versionVisible)}
      ></VersionSelection>
    </div>
  );
}

export default connect((state: any) => {
  const { opinionCommon, home } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
    userInfo: home.userInfo,
  };
})(NavBody);
